<template>
  <div id="project-summary">
    <div class="col-lg-12" v-if="project">
      <div class="hpanel">
        <div class="panel-heading">
          Project Summary
          <div class="pull-right text-right">
            <div class="btn-group">
              <router-link class="btn btn-info btn-xs" :to="{name: 'ProjectDetails', params: {id: project.id}}"> <i class="fa fa-eye"></i> Project overview</router-link>
            </div>
          </div>

        </div>
        <div class="panel-body">
          <div class="row">

            <div class="col-sm-12 col-md-4" style="">
              <label>Subproject</label>
              <v-select2 v-model="listSelected" class="form-control" label="title" :options="project.lists"></v-select2>
            </div>

            <div class="col-sm-12 col-md-8">
              <div class="row" style="margin-top: 15px">
                <div class="col-xs-12">
                  <span class="col-xs-4">Selected experts</span>
                  <span class="col-xs-2 text-success bold text-left">{{authorsSelected.length}}</span>
                  <span class="col-xs-4">Similar experts</span>
                  <span class="col-xs-2 text-warning bold text-left">{{authorsSimilar.length}}</span>
                </div>
                <div style="margin-top: 5px" class="col-xs-12">
                  <span class="col-xs-4">Selected companies</span>
                  <span class="col-xs-2 text-success bold text-left">{{companiesSelected.length}}</span>
                  <span class="col-xs-4">Similar companies</span>
                  <span class="col-xs-2 text-warning bold text-left">{{companiesSimilar.length}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>
<script>

import VSelect2 from '../utils/select2'

export default {
  components: {VSelect2},
  name: 'projectBox',
  props: ['project', 'authorsSimilar', 'authorsSelected', 'companiesSelected', 'companiesSimilar', 'listIdSelected'],
  data () {
    return {
      question: null,
      listSelected: null
    }
  },
  watch: {
    project: function (project) {
      if (project !== null) {
        this.getListSelected()
      }
    },
    listSelected: function (val) {
      if (val !== null) {
        this.$emit('update:listIdSelected', val.id)
      } else {
        this.$emit('update:listIdSelected', null)
      }
    }
  },
  methods: {
    getListSelected: function () {
      let listIdSelected = parseInt(localStorage.getItem('listIdSelected'))

      if (this.project.lists.length !== 0) {
        this.listSelected = this.project.lists.find((list) => {
          return list.id === listIdSelected
        })
      }

      if (this.project.lists.length === 0 || typeof this.listSelected === 'undefined') {
        this.listSelected = null
      }
    }
  },
  mounted () {
    this.$eventHub.$on('addSuggestionToBiblio', (suggestion, wiki) => {
    })
  },
  beforeMount () {
    if (this.project !== null) {
      this.getListSelected()
    }
  },
  beforeDestroy () {
    this.$eventHub.$off('addSuggestionToBiblio')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ProjectBox.vue